export const IMGIX_URL = "https://coastandvineschurch.imgix.net/";
